var n;!function(n){n.ja="ja-JP",n.en="en-US",n.ko="ko-KR",n.zh="zh-CN"}(n||(n={}));export{n as Locale};
//# sourceMappingURL=Locale.js.map
